// ---------------------------------------------------------------------------
// YouAreYou (uru) — useAuth Hook
//
// Extracted to a separate file so that AuthContext.tsx only exports
// components, satisfying eslint-plugin-react-refresh's requirement
// that files with components don't also export non-component bindings.
// ---------------------------------------------------------------------------

import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "@/context/authTypes";

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth() must be used within an <AuthProvider>");
  }
  return context;
}
